import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'job', en);

const JobListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Pack Management',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.JOB,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/job/list',
      component: React.lazy(() => import('./JobList')),
    },
  ],
};

export default JobListConfig;
